import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { installCtaTracking, startPageBehavior } from '../services/marketingBehavior';

export default function MarketingTracking() {
  const { pathname, key } = useLocation();
  useEffect(installCtaTracking, []);
  useEffect(() => {
    if (pathname.toLowerCase().replace(/\/+$/, '') === '/how-it-works') return startPageBehavior();
  }, [pathname, key]);
  return null;
}
